var classes = {"sbt-chip":"index-module_sbt-chip__fj-ed","size-small":"index-module_size-small__PzfwT","weight-book":"index-module_weight-book__8RzzL","disabled":"index-module_disabled__0tOCC","size-medium":"index-module_size-medium__hCg3i"};

export { classes as default };
//# sourceMappingURL=index.module.scss.js.map
